import { ChartColumn, Folder, Info, Table2 } from "lucide-react";
import { Link, useLocation } from "react-router";

import { useCheckFeatureFlag } from "@/shared/domain/featureFlags/hooks/useCheckFeatureFlag";
import { Tab, Tabs, TabsList } from "@/shared/foundation/primitives";

import styles from "./SessionDetail.module.css";
import { SessionTab, useActiveSessionTab } from "./useActiveSessionTabFromUrl";

/**
 * Tab strip for the session-detail page. Reads its active value from
 * the URL via `useActiveSessionTab`, so it carries no session-record
 * dependency and can render unconditionally — including inside the
 * page's error fallback when the session fetch fails.
 */
export function SessionTabBar() {
  const activeTab = useActiveSessionTab();
  const location = useLocation();
  const metricsTabEnabled = useCheckFeatureFlag("release-metrics");

  const tabs = [
    { tab: SessionTab.Topics, label: "Topics", Icon: Table2 },
    { tab: SessionTab.Sources, label: "Sources", Icon: Folder },
    {
      tab: SessionTab.Metrics,
      label: "Metrics",
      Icon: ChartColumn,
      shown: metricsTabEnabled,
    },
    { tab: SessionTab.Details, label: "Details", Icon: Info },
  ];

  return (
    <Tabs className={styles.tabBar} value={activeTab}>
      <TabsList aria-label="session tabs">
        {tabs
          .filter(({ shown }) => shown !== false)
          .map(({ tab, label, Icon }) => (
            <Tab
              key={tab}
              value={tab}
              nativeButton={false}
              render={
                <Link to={{ pathname: tab, search: location.search }} replace />
              }
            >
              <Icon aria-hidden />
              {label}
            </Tab>
          ))}
      </TabsList>
    </Tabs>
  );
}
